import React from 'react'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './DateTimePicker.css'
import { useSelector } from 'react-redux'
import { colorThemes, I18n } from 'galarm-config'

const DefaultDateInput = React.forwardRef(function DefaultDateInput(
  { value, onClick, placeholder, textColor, borderColor },
  ref
) {
  return (
    <input
      ref={ref}
      value={value || ''}
      onClick={onClick}
      readOnly
      placeholder={placeholder}
      style={{
        color: textColor,
        backgroundColor: 'transparent',
        border: `1px solid ${borderColor}`,
        borderRadius: 4,
        padding: '8.5px 14px',
        fontSize: '1rem',
        cursor: 'pointer',
        outline: 'none',
        width: '100%',
        boxSizing: 'border-box'
      }}
    />
  )
})

const DateInput = ({ value, onChange, customInput, ...rest }) => {
  const colorScheme = useSelector(state => state.userSettings.webColorScheme)
  const theme = colorThemes.getColorTheme(colorScheme)
  const isDark = colorScheme === 'dark' || colorScheme === 'autoDark'

  const safeValue =
    value instanceof Date && !isNaN(value.getTime()) ? value : null

  const defaultInput = (
    <DefaultDateInput
      textColor={theme.textColor}
      borderColor={theme.darkTint}
    />
  )

  return (
    <ReactDatePicker
      selected={safeValue}
      onChange={onChange}
      dateFormat="d MMM yyyy"
      placeholderText={I18n.t('specifyDate')}
      customInput={customInput || defaultInput}
      popperClassName={isDark ? 'dtp-dark' : 'dtp-light'}
      {...rest}
    />
  )
}

export default DateInput
